// extracted by mini-css-extract-plugin
export default {"root":"QuotaSpacePromo__root--2Ikb0","img":"QuotaSpacePromo__img--3fDkm","buttonText":"QuotaSpacePromo__buttonText--1r8IW","subTitle":"QuotaSpacePromo__subTitle--1zrhr"};